import classNames from 'classnames'
import { observer } from 'mobx-react'
import React, { FC, useRef, useState, TouchEvent } from 'react'
import styles from './CustomerEntry.module.less'
import { useScrolling } from 'react-use'
import { commonUtils } from '@/helpers/commonUtils'
import { uiController } from '@/controllers/uiController'
// import { userService } from '@/services/userService/userService'
interface CustomerEntryProps {}

function MobilePhoneIcon() {
  return (
    <svg className={styles.phoneIcon} viewBox='0 0 24 24' aria-hidden='true'>
      <path d='M20.2 16.8v2a1.8 1.8 0 0 1-2 1.8c-3.2-.3-6.1-1.7-8.5-4.1-2.4-2.4-3.8-5.3-4.1-8.5a1.8 1.8 0 0 1 1.8-2h2a1.8 1.8 0 0 1 1.7 1.5c.1.7.3 1.4.5 2a1.8 1.8 0 0 1-.4 1.8l-.8.8a12.7 12.7 0 0 0 4.8 4.8l.8-.8a1.8 1.8 0 0 1 1.8-.4c.6.2 1.3.4 2 .5a1.8 1.8 0 0 1 1.4 1.6z' />
      <path d='M14.6 5.6a5.9 5.9 0 0 1 3.8 3.8' />
      <path d='M14.2 2.8a9 9 0 0 1 7 7' />
    </svg>
  )
}

const CustomerEntry: FC<CustomerEntryProps> = observer((props: CustomerEntryProps) => {
  const scrollRef = useRef(document.body)
  const scrolling = useScrolling(scrollRef)

  // 添加位置状态
  const [position, setPosition] = useState({
    top: 'auto',
    bottom: '40px',
    left: 'auto',
    right: '6px',
  })
  const [isDragging, setIsDragging] = useState(false)
  const movedRef = useRef(false)
  // const [startPosition, setStartPosition] = useState({ x: 0, y: 0 })

  // 处理触摸开始事件
  const handleTouchStart = (e: TouchEvent) => {
    setIsDragging(true)
    movedRef.current = false
    // setStartPosition({
    //   x: e.touches[0].clientX,
    //   y: e.touches[0].clientY,
    // })
  }

  // 处理触摸移动事件
  const handleTouchMove = (e: TouchEvent) => {
    if (!isDragging) return
    movedRef.current = true

    // 只允许垂直方向拖动，保持水平位置不变
    const newTop = `${e.touches[0].clientY - 44}px` // 88px是整组高度，保持手指接近中点

    setPosition({
      top: newTop,
      bottom: 'auto',
      left: 'auto',
      right: '6px',
    })
  }

  // 处理触摸结束事件
  const handleTouchEnd = () => {
    setIsDragging(false)
  }

  // 处理点击事件，只在非拖动状态下触发
  const handleClick = () => {
    if (!isDragging && !movedRef.current) {
      uiController.contactPopupProps.visible = true
      // userService.openCustomerService()
    }
  }

  const handlePhoneClick = () => {
    if (isDragging || movedRef.current) return
      window.location.href = 'tel:15927803545'
  }

  return (
    <div
      className={classNames(styles.customerEntryGroup, {
        [styles.opacity]: scrolling,
      })}
      style={position}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <button className={styles.customerEntry} onClick={handleClick} type='button'>
        <img src={commonUtils.getStaticFile('images/icon__customer.png')} alt='icon__customer' />
      </button>
      <button
        className={classNames(styles.customerEntry, styles.phoneEntry)}
        type='button'
        aria-label='电话咨询'
        onClick={handlePhoneClick}
      >
        <MobilePhoneIcon />
      </button>
    </div>
  )
})

export default CustomerEntry
